// extracted by mini-css-extract-plugin
export var card = "TimelineItems-module--card--886e2";
export var flag = "TimelineItems-module--flag--e6d6a";
export var marker = "TimelineItems-module--marker--16af1";
export var normal = "TimelineItems-module--normal--0bf7c";
export var sectionTitle = "TimelineItems-module--sectionTitle--a0818";